import {Typography} from '@yandex-delivery/ui'
import {SafeHTML} from '@yandex-delivery/xss-defender'
import React from 'react'

import {useBlocksLayout} from '../../../BlocksLayoutProvider'

type Props = {
  title: string
  small?: boolean
}

export function Title({title, small}: Props) {
  const {isMobile} = useBlocksLayout()

  return (
    <Typography density="tight" level={small ? 'body2' : isMobile ? 'body1' : 'title4'} weight="medium">
      <SafeHTML html={title} />
    </Typography>
  )
}
